import React from 'react'

import Link from 'next/link'

import CloudinaryImage from '@/components/CloudinaryImage'
import { Place } from '@/types'

interface BestOfPlaceCardProps {
  place: Place
  index: number
  category: string
}

const BestOfPlaceCard: React.FC<BestOfPlaceCardProps> = ({
  place,
  index,
  category
}) => {
  const placeLink = `/${place.destination}/${category.toLowerCase()}/${
    place.slug
  }`

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden">
      <Link href={placeLink}>
        <div className="relative h-48">
          <CloudinaryImage
            src={`/images/places/${place.destination}/${place.slug}`}
            alt={place.name}
            width={400}
            height={300}
            className="object-cover w-full h-full"
          />
          <div className="absolute top-2 left-2 bg-blue-500 text-white px-2 py-1 rounded-full text-sm font-bold">
            #{index + 1}
          </div>
        </div>
      </Link>
      <div className="p-4">
        <Link href={placeLink}>
          <h3 className="text-xl font-semibold mb-2">{place.name}</h3>
        </Link>
        <p className="text-gray-600 dark:text-gray-300 text-sm mb-2">
          {place.address}
        </p>
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <span className="text-yellow-400 mr-1">★</span>
            <span className="font-bold">
              {place.rating?.toFixed(1) || 'N/A'}
            </span>
            <span className="text-gray-500 dark:text-gray-400 ml-1">
              ({place.reviews?.toLocaleString() || 0} reviews)
            </span>
          </div>
          <Link href={placeLink} className="text-blue-500 hover:underline">
            Learn More
          </Link>
        </div>
      </div>
    </div>
  )
}

export default BestOfPlaceCard
